import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IBrandsAndCategories = {
  categories: [],
  brands: [],
};

const brandsAndCategoriesSlice = createSlice({
  name: "brandsAndCategories",
  initialState,
  reducers: {
    setBrands: (state, action: PayloadAction<{ brands: Brand[] }>) => {
      const { brands } = action.payload;
      state.brands = brands;
    },
    setCategories: (
      state,
      action: PayloadAction<{ categories: Category[] }>
    ) => {
      const { categories } = action.payload;
      state.categories = categories;
    },
  },
});
export const { setBrands, setCategories } = brandsAndCategoriesSlice.actions;
export default brandsAndCategoriesSlice.reducer;
